export default __webpack_public_path__ + "static/media/s7u4rt99.8f02328e.png";